'use client';

import { useEffect, useState } from 'react';

/** CSS background 이미지는 onError가 없어서 미리 로드해 보고 실패하면 fallback으로 바꾼다 */
export function useImageFallback(src: string, fallback: string) {
  const [current, setCurrent] = useState(src);

  useEffect(() => {
    const img = new Image();
    img.onerror = () => setCurrent(fallback);
    img.src = src;

    return () => {
      img.onerror = null;
    };
  }, [src, fallback]);

  return current;
}
